import React from 'react';
import { Link } from 'react-router-dom';
import { ENTITY_TYPES, entityPath, entityLabel } from '../config/entityRoutes';
import { observableTypeLabel } from '../config/openctiObservables';

function EntityPivotLink({
  type,
  id,
  label,
  sublabel,
  iocType,
  badgeLabel,
  className = '',
  showBadge = true,
}) {
  if (!type) return <span className={className}>{label || '—'}</span>;

  const config = ENTITY_TYPES[type] || {};
  const path = id ? entityPath(type, id) : entityPath(type, '');
  const display = label || id || entityLabel(type);
  const badgeText = badgeLabel
    || (iocType ? observableTypeLabel(iocType) : null)
    || entityLabel(type);

  const content = (
    <>
      {showBadge && (
        <span className={`entity-badge ${config.badge || 'entity-badge-default'}`} title={entityLabel(type)}>
          {badgeText}
        </span>
      )}
      <span className="entity-pivot-label">{display}</span>
      {sublabel && <span className="entity-pivot-sublabel">{sublabel}</span>}
    </>
  );

  if (!path || path === '/') {
    return <span className={`entity-pivot-link static ${className}`}>{content}</span>;
  }

  return (
    <Link to={path} className={`entity-pivot-link ${className}`}>
      {content}
    </Link>
  );
}

export default EntityPivotLink;
